import type { ButtonHTMLAttributes } from "react";

type LikeDirection = "up" | "down";
type LikeButtonSize = "md" | "lg";

interface LikeButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  direction: LikeDirection;
  count: number;
  loading?: boolean;
  size?: LikeButtonSize;
}

export function LikeButton({
  direction,
  count,
  loading = false,
  disabled,
  size = "md",
  className = "",
  ...buttonProps
}: LikeButtonProps) {
  const isUp = direction === "up";
  const iconSize = size === "lg" ? "w-6 h-6" : "w-5 h-5";
  const textSize = size === "lg" ? "text-lg" : "text-base";
  const padding = size === "lg" ? "px-4 py-2.5" : "px-3 py-2";
  
  const baseStyles = isUp
    ? "bg-gradient-to-r from-amber-500/80 to-orange-500/80 hover:from-amber-500 hover:to-orange-500 border-amber-400/50"
    : "bg-gradient-to-r from-slate-600/80 to-slate-700/80 hover:from-slate-600 hover:to-slate-700 border-slate-500/50";

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={isUp ? "Like" : "Unlike"}
      className={`group flex items-center justify-center gap-2 rounded-lg border ${baseStyles} text-white font-semibold ${padding} ${textSize} transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 disabled:opacity-50 disabled:cursor-not-allowed hover:scale-105 hover:shadow-lg active:scale-95 ${className}`}
      {...buttonProps}
    >
      <span className={`${iconSize} transition-transform group-hover:scale-110 ${loading ? "animate-pulse" : ""}`}>
        {isUp ? "👍" : "👎"}
      </span>
      <span className="font-bold tabular-nums">{loading ? "..." : count}</span>
    </button>
  );
}

